<template>
<div class="apps-list-container">
    <h3>Nossos produtos</h3>
    <br/>
    <div class="container apps-list">
        <div v-for="(app, index) in apps" :key="index" class="col-sm-3">
            <app-item :app="app"></app-item>
        </div>
    </div>
    <br/>
    <br/>
    <br/>
</div>
</template>

<script>

import AppItem from './AppItem'

export default {
  name: 'AppList',
    components: {
        AppItem
    },
    data() {
        return {
            apps: [
                {
                    link: "https://play.google.com/store/apps/details?id=br.com.parciais.parciais&hl=pt_BR",
                    img: require('./../assets/logo-parciais.png'),
                    name: "Parciais CFC Android"
                },
                {
                    link: "https://apps.apple.com/br/app/parciais-cfc/id1363658556",
                    img: require('./../assets/logo-parciais.png'),
                    name: "Parciais CFC iOS"
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.apps-list {
    display: flex;
    justify-content: space-around;
}
</style>